/**
 * Image With Text Overlay Custom Element
 * Registers the <image-with-text-overlay> custom element for use in sections
 */
if (!window.customElements.get("image-with-text-overlay")) {
  class ImageWithTextOverlay extends HTMLElement {
    constructor() {
      super();
      this.preventInitialTransition = false;

      if (Shopify && Shopify.designMode) {
        this.closest(".shopify-section")?.addEventListener("shopify:section:select", (event) => {
          this.preventInitialTransition = event.detail.load;
        });
      }
    }

    connectedCallback() {
      // Check if reveal-on-scroll is enabled and user prefers motion
      const revealOnScroll = this.getAttribute("reveal-on-scroll") === "true";
      const prefersMotion = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;

      if (revealOnScroll && prefersMotion) {
        this.setupRevealOnScroll();
      } else {
        // Show immediately if no reveal animation
        this.style.opacity = "1";
      }
    }

    setupRevealOnScroll() {
      // Simple intersection observer for reveal animation
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.animateIn();
              observer.unobserve(this);
            }
          });
        },
        { threshold: 0.05 }
      );

      observer.observe(this);
    }

    async animateIn() {
      // The element itself has the content-over-media class, so we look for direct children
      const media = this.querySelector("picture img, svg");
      const content = this.querySelector(".content");

      if (this.preventInitialTransition) {
        this.style.opacity = "1";
        if (media) media.style.opacity = "1";
        if (content) content.style.opacity = "1";
        return;
      }

      // Wait for image to load
      if (media && media.tagName === "IMG") {
        await new Promise((resolve) => {
          if (media.complete) {
            resolve();
          } else {
            media.addEventListener("load", resolve, { once: true });
          }
        });
      }

      // Animate element, media, and content
      this.style.opacity = "0";
      this.style.transition = "opacity 0.8s ease";

      if (media) {
        media.style.opacity = "0";
        media.style.transition = "opacity 0.8s ease, transform 0.8s ease";
        media.style.transform = "scale(1.1)";
      }

      if (content) {
        content.style.opacity = "0";
        content.style.transition = "opacity 0.8s ease";
      }

      requestAnimationFrame(() => {
        this.style.opacity = "1";
        if (media) {
          media.style.opacity = "1";
          media.style.transform = "scale(1)";
        }
        if (content) {
          content.style.opacity = "1";
        }
      });
    }
  }

  window.customElements.define("image-with-text-overlay", ImageWithTextOverlay);
}

